<template>
  <PopupTemplate @close="$emit('close')">
    <NuevoEmail v-if="paso == 'pedirEmail'" @siguiente="siguiente" />
    <SeleccionPolizas v-if="paso == 'aplicarPolizas'" :campo="'e-mail'" @siguiente="siguiente" />
    <ResultadoCambio v-if="paso == 'resultado'" :campo="'e-mail'" @siguiente="siguiente" />
    <div v-if="errorEmail" class="noValido">{{ errorEmail }}</div>
  </PopupTemplate>
</template>

<script>
export default {
  props: {
    idPoliza: { type: Number, required: false, default: 0 },
    ramo: { type: String, required: false, default: "" },
  },

  data() {
    return {
      paso: "pedirEmail",
      errorEmail: "",
    };
  },

  computed: {
    tieneMasDeUnaPoliza() {
      return this.$store.state.portfolio.totalPolizasVigorMMT > 1;
    },
    telefAtencion() {
      return this.$store.state.telefonoAtencion;
    },
    telefAtencionGratuito() {
      return this.$store.state.telefonoAtencionGratuito;
    },
  },

  methods: {
    actualizarEmail: async function () {
      console.log("Actualizar email: " + this.$store.state.nuevoEmail + " en pólizas:" + this.$store.state.polizasSel);
      let result = await this.$store.dispatch("actualizarEmail", {
        email: this.$store.state.nuevoEmail,
        polizas: this.$store.state.polizasSel,
      });

      console.log(result);
      if (result.codigo != 0) {
        this.errorEmail =
          "Se ha producido un error. Por favor, contacte con Atención al Cliente en los teléfonos " +
          this.telefAtencionGratuito +
          " o " +
          this.telefAtencion;
        return;
      }

      this.$store.dispatch("getPortfolio");

      this.paso = "resultado";
    },

    siguiente: async function () {
      switch (this.paso) {
        case "pedirEmail":

          if (this.tieneMasDeUnaPoliza) {
            // Pasamos a seleccionar la poliza
            console.log("Tiene mas de una poliza : " + this.tieneMasDeUnaPoliza);
            this.paso = "aplicarPolizas";
          } else {


            if (this.tieneMasDeUnaPoliza) {
              // Pasamos a seleccionar la poliza
              console.log("Tiene mas de una poliza : " + this.tieneMasDeUnaPoliza);
              this.paso = "aplicarPolizas";
            } else {

              if (this.$store.state.portfolio.lstPolizasSaludHNA.length == 1) {
                // En este caso solo se cambia el cliente
                const arrayPoliza = new Array();
                this.$store.dispatch("setPolizasSel", arrayPoliza);
                this.actualizarEmail();
              } else {

                const arrayPoliza = new Array();
                if (this.$store.state.portfolio.lstPolizasHogar.length > 0) {
                  arrayPoliza.push(this.$store.state.portfolio.lstPolizasHogar[0].idPoliza);
                }
                if (this.$store.state.portfolio.lstPolizasVeh.length > 0) {
                  arrayPoliza.push(this.$store.state.portfolio.lstPolizasVeh[0].idPoliza);
                }
                if (this.$store.state.portfolio.lstPolizasDec.length > 0) {
                  arrayPoliza.push(this.$store.state.portfolio.lstPolizasDec[0].idPoliza);
                }
                if (this.$store.state.portfolio.lstPolizasMovilidad.length > 0) {
                  arrayPoliza.push(this.$store.state.portfolio.lstPolizasMovilidad[0].idPoliza);
                }
                if (this.$store.state.portfolio.lstPolizasNegocio.length > 0) {
                  arrayPoliza.push(this.$store.state.portfolio.lstPolizasNegocio[0].idPoliza);
                }
                if (this.$store.state.portfolio.lstPolizasAccidentes.length > 0) {
                  arrayPoliza.push(this.$store.state.portfolio.lstPolizasAccidentes[0].idPoliza);
                }
                if (this.$store.state.portfolio.lstPolizasMascotas.length > 0) {
                  arrayPoliza.push(this.$store.state.portfolio.lstPolizasMascotas[0].idPoliza);
                }
                if (this.$store.state.portfolio.lstPolizasSaludMMT.length > 0) {
                  arrayPoliza.push(this.$store.state.portfolio.lstPolizasSaludMMT[0].idPoliza);
                }
                this.$store.dispatch("setPolizasSel", arrayPoliza);
                this.actualizarEmail();
              }

            }

          }

          break;

        case "aplicarPolizas":
          this.actualizarEmail();
          break;
        case "resultado":
          this.$emit("close");
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.noValido {
  color: red;
  font-weight: bold;
}

.cabecera {
  font-size: 120%;
  margin-bottom: 1rem;
  color: $colorMMT;
  border-bottom: 2px solid $azulOscuroMMT;
}

.texto {
  font-size: 90%;
  margin-bottom: 1rem;
  color: $azulOscuroMMT;
}

.panel {
  display: flex;
  flex-flow: column nowrap;

  label {
    display: block;
  }

  input {
    width: 100%;
  }

  button {
    background-color: $colorMMT;
    color: white;
    margin-top: 1rem;
  }
}

.contenedor {
  width: 100%;
  max-width: 30rem;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 5px;
  padding: 2rem;
}

.sep {
  height: 0.8rem;
}
</style>
